import React, { useState, useEffect, useCallback } from 'react';
import ModuleTemplate from '../../ModuleTemplate';
import { useInstructionAudio } from '../../lib/useInstructionAudio';
import './GroupPictures.css';

const S3_BASE_URL = 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/vocabulary';

const EXERCISES = [
  // Задание 1 (Базовое - Питомцы)
  {
    id: 'pets',
    items: [
            { id: 'dog_paws', groupId: 'dog', img: 'dog_paws' },
      { id: 'dog_house', groupId: 'dog', img: 'dog_house' },
      { id: 'dog_bowl', groupId: 'dog', img: 'dog_bowl' },
      { id: 'dog', groupId: 'dog', img: 'dog_' },
      { id: 'cat_paws', groupId: 'cat', img: 'cat_paws' },
      { id: 'cat_bed', groupId: 'cat', img: 'cat_bed' },
      { id: 'cat_bowl', groupId: 'cat', img: 'cat_bowl' },
      { id: 'cat', groupId: 'cat', img: 'cat_' },
      { id: 'parrot_paws', groupId: 'parrot', img: 'parrot_paws' },
      { id: 'cage', groupId: 'parrot', img: 'parrot_cage' },
      { id: 'parrot_bowl', groupId: 'parrot', img: 'parrot_bowl' },
      { id: 'parrot', groupId: 'parrot', img: 'parrot_' },

    ]
  },
  // Задание 2 (Животные)
  {
    id: 'animals',
    items: [
      { id: 'cow', groupId: 'farm', img: 'cow' },
      { id: 'horse', groupId: 'farm', img: 'horse' },
      { id: 'goat', groupId: 'farm', img: 'goat' },
      { id: 'sheep', groupId: 'farm', img: 'sheep' },
      { id: 'bear', groupId: 'forest', img: 'bear' },
      { id: 'fox', groupId: 'forest', img: 'fox' },
      { id: 'wolf', groupId: 'forest', img: 'wolf' },
      { id: 'hare', groupId: 'forest', img: 'olen' },
      { id: 'elephant', groupId: 'africa', img: 'elephant' },
      { id: 'giraffe', groupId: 'africa', img: 'giraffe' },
      { id: 'zebra', groupId: 'africa', img: 'zebra' },
      { id: 'lion', groupId: 'africa', img: 'lion' },

    ]
  },
  // Задание 3 (Птицы)
  {
    id: 'birds',
    items: [
      { id: 'hen', groupId: 'dom_bird', img: 'hen' },
      { id: 'duck', groupId: 'dom_bird', img: 'duck' },
      { id: 'goose', groupId: 'dom_bird', img: 'goose' },
      { id: 'turkey', groupId: 'dom_bird', img: 'turkey' },
      { id: 'pigeon', groupId: 'city_bird', img: 'pigeon' },
      { id: 'sparrow', groupId: 'city_bird', img: 'sparrow' },
      { id: 'crow', groupId: 'city_bird', img: 'crow' },
      { id: 'tit', groupId: 'city_bird', img: 'tit' },
      { id: 'owl', groupId: 'forest_bird', img: 'owl' },
      { id: 'woodpecker', groupId: 'forest_bird', img: 'woodpecker' },
      { id: 'woodgrouse', groupId: 'forest_bird', img: 'wood_grouse' },
      { id: 'grouse', groupId: 'forest_bird', img: 'grouse' },

    ]
  }
];

const ZONES = [
  { id: 'zone1' },
  { id: 'zone2' },
  { id: 'zone3' },
];

const GroupPictures = ({ ageGroup, onBack, onComplete }) => {
  const [tasks] = useState(() => [...EXERCISES].sort(() => Math.random() - 0.5));
  const [currentIndex, setCurrentIndex] = useState(0);
  const [items, setItems] = useState(() => [...tasks[0].items].sort(() => Math.random() - 0.5));
  const [placedItems, setPlacedItems] = useState({}); 
  const [selectedItem, setSelectedItem] = useState(null);
  const [feedback, setFeedback] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [answers, setAnswers] = useState([]);

  // === ОЗВУЧКА ИНСТРУКЦИИ ===
  const { play: playInstructionAudio, stop: stopInstructionAudio } = useInstructionAudio();

  const playInstruction = useCallback(() => {
    playInstructionAudio('Посмотри на картинки. Разложи их по группам. Когда выполнишь задание, нажми кнопку ОК.');
  }, [playInstructionAudio]);

  // Запуск озвучки при старте и при смене задания
  useEffect(() => {
    playInstruction();
  }, [currentIndex, playInstruction]);

  // Очистка озвучки при выходе из компонента
  useEffect(() => {
    return () => stopInstructionAudio();
  }, [stopInstructionAudio]);

  const handleSelectItem = (itemId) => {
    if (isProcessing) return;
    
    if (placedItems[itemId]) {
      const newPlaced = { ...placedItems };
      delete newPlaced[itemId];
      setPlacedItems(newPlaced);
    }
    setSelectedItem(prev => prev === itemId ? null : itemId);
  };

  const handlePlaceItem = (zoneId) => {
    if (!selectedItem || isProcessing) return;
    setPlacedItems(prev => ({ ...prev, [selectedItem]: zoneId }));
    setSelectedItem(null);
  };

  const checkAnswer = () => {
    if (isProcessing) return;
    setIsProcessing(true);

    let isCorrect = true;
    ZONES.forEach(zone => {
      const itemsInZone = items.filter(i => placedItems[i.id] === zone.id);
      if (itemsInZone.length !== 4) {
        isCorrect = false;
      } else {
        const firstGroup = itemsInZone[0].groupId;
        const allMatch = itemsInZone.every(i => i.groupId === firstGroup);
        if (!allMatch) isCorrect = false;
      }
    });

    setFeedback(isCorrect ? 'correct' : 'wrong');

    setTimeout(() => {
      const newAnswers = [...answers, isCorrect];
      setAnswers(newAnswers);

      if (currentIndex < tasks.length - 1) {
        const nextIndex = currentIndex + 1;
        setPlacedItems({});
        setSelectedItem(null);
        setIsProcessing(false);
        setFeedback(null);
        setItems([...tasks[nextIndex].items].sort(() => Math.random() - 0.5));
        setCurrentIndex(nextIndex);
      } else {
        const correctCount = newAnswers.filter(a => a).length;
        const score = Math.round((correctCount / tasks.length) * 100);
        if (onComplete) onComplete({ testId: 'GroupPictures', score });
        else onBack();
      }
    }, 1500);
  };

  const placedCount = Object.keys(placedItems).length;
  const allPlaced = placedCount === 12;

  if (feedback) {
    return (
      <ModuleTemplate progress={answers} totalQuestions={tasks.length} forceStop={true} onComplete={onComplete || onBack}>
        <div className="gp-result-content">
          <h2 className="gp-result-title" style={{ color: feedback === 'correct' ? '#10B981' : '#EF4444' }}>
            {feedback === 'correct' ? '🎉 Верно!' : '❌ Ошибка!'}
          </h2>
        </div>
      </ModuleTemplate>
    );
  }

  return (
    <ModuleTemplate 
      progress={answers} 
      totalQuestions={tasks.length} 
      forceStop={true} 
      onComplete={onComplete || onBack}
      onRepeat={playInstruction} // Передаем функцию повтора озвучки в шаблон
      extraContent="Сгруппируй картинки"
      extraButtons={
        <button 
          className="gp-confirm-btn" 
          onClick={checkAnswer} 
          disabled={!allPlaced || isProcessing}
        >
          ОК
        </button>
      }
    >
      <div className="gp-game-area">
        
        <div className="gp-zones-row">
          {ZONES.map(zone => {
            const itemsInZone = items.filter(item => placedItems[item.id] === zone.id);
            
            return (
              <div 
                key={zone.id} 
                className={`gp-zone ${selectedItem ? 'active' : ''}`}
                onClick={() => handlePlaceItem(zone.id)}
              >
                {itemsInZone.length === 0 && (
                  <div className="gp-zone-placeholder">?</div>
                )}
                <div className="gp-zone-items">
                  {itemsInZone.map(item => (
                    <img 
                      key={item.id} 
                      src={`${S3_BASE_URL}/${item.img}.png`} 
                      alt="" 
                      className="gp-placed-img"
                      onClick={(e) => { e.stopPropagation(); handleSelectItem(item.id); }}
                      onError={(e) => { e.target.src = '/placeholder.png'; }}
                    />
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        <div className="gp-items-grid">
          {items.map(item => {
            const isPlaced = !!placedItems[item.id];
            const isSelected = selectedItem === item.id;
            
            return (
              <div 
                key={item.id} 
                className={`gp-item-card ${isPlaced ? 'placed' : ''} ${isSelected ? 'selected' : ''}`}
                onClick={() => handleSelectItem(item.id)}
              >
                <img 
                  src={`${S3_BASE_URL}/${item.img}.png`} 
                  alt="" 
                  className="gp-item-img"
                  onError={(e) => { e.target.src = '/placeholder.png'; }}
                />
              </div>
            );
          })}
        </div>

      </div>
    </ModuleTemplate>
  );
};

export default GroupPictures;